import { render } from "./OwnerAccount-EditCompany.vue?vue&type=template&id=68f9e9e7&scoped=true"
import script from "./OwnerAccount-EditCompany.vue?vue&type=script&lang=js"
export * from "./OwnerAccount-EditCompany.vue?vue&type=script&lang=js"

import "./OwnerAccount-EditCompany.vue?vue&type=style&index=0&id=68f9e9e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f9e9e7"]])

export default __exports__